/**
 * Returns the number of full stars to be displayed,
 * and whether an extra half star should be displayed.
 * Adapted from: https://w.amazon.com/bin/view/Customer_Reviews/Customers/Use_on_other_amazon_properties/#Technical_Requirements
 */
export function roundStars(input: string) {
  let starRating = parseFloat(input);
  if (isNaN(starRating)) {
    starRating = 0;
  }
  let hasHalfStar = false;
  let parts = starRating.toFixed(1).split('.');
  let fullStarCount = parseInt(parts[0], 10);
  let minor = parseInt(parts[1], 10);

  // This minor digit math is from the above wiki
  // and is intended to avoid issues with float rounding
  if (minor >= 3 && minor <= 7) {
    hasHalfStar = true;
  } else if (minor > 7) {
    fullStarCount++;
  }
  return { fullStarCount, hasHalfStar };
}
